import React from 'react';
import TabbedWorkspaceContainer from '../TabbedWorkspaceContainer/TabbedWorkspaceContainer';
import { aggregateLabelMap } from '../../staticData';
import AvailabilityTab from '../../components/AvailabilutyTab/AvailabilityTab';
import { AggregateLineOn } from '../../components';

const AvailabilityTabView = ({ aggregate }) => {
  const tabs = [
    { label: 'Available', component: AvailabilityTab, props: { aggregate } },
    {
      label: 'Lineout Update',
      component: AggregateLineOn,
      props: { aggregate },
    },
  ];

  const title = aggregateLabelMap[aggregate];
  return <TabbedWorkspaceContainer isAggregate={true} pageTitle={title} tabs={tabs} />;
};

export default AvailabilityTabView;
